export default {
  init() {
    // Insert submenu images
    $('.header .main-menu__item--parent > a[data-image]').each(function() {
      $(this).next('.main-menu__sub-menu').find('.sub-menu-columns').append('<div class="sub-menu-wrapper__media"><img src="' + $(this).attr('data-image') + '"/></div>')
    })

    // Top bar
    $(window).on('load orientationchange resize message_dismissed', topBarHeight)
    topBarHeight()

    function topBarHeight() {
      let $topBar = $('.featured-message--style-top-bar'),
      $menuBar = $('.header__main'),
      topBarHeight = 0,
      menuBarHeight = 0,
      headerHeight = 0
      if ($topBar.length && $topBar.is(':visible')) {
        topBarHeight = $topBar.outerHeight(false)
      }
      if ($menuBar.length && $menuBar.is(':visible')) {
        menuBarHeight = $menuBar.outerHeight(false)
      }
      headerHeight = menuBarHeight
      if (topBarHeight && !$('body').hasClass('header--scroll-down') && !$('body').hasClass('--menu-open')) {
        headerHeight += topBarHeight
      }
      $('body').css({
        '--top-bar-height': topBarHeight + 'px',
        '--menu-height': menuBarHeight + 'px',
        '--header-height': headerHeight + 'px',
      })
    }

    if ($('html').hasClass('no-status')) {
      $.ajax({
        url: '/auth/user/',
        type: 'POST',
        data: {},
        success: function (response) {
          $('html').removeClass('no-status').addClass('no-ads')
          $('.secondary-menu a').each(function() {
            const href = $(this).attr('href')
            if (href === '/auth/login/' || href === '/auth/logout/') {
              $(this).attr('href', href + '?origin=' + encodeURIComponent(window.location.pathname))
            }
          })
          if (response.success && response.data.is_logged_in) {
            if (response.data.level == 'free') {
              $('.header__pro__subscribe a').text(techicons_l10n.upgrade).attr('href', '/account/subscription-billing/')
              $('.secondary-menu__item--btn-primary a').text(techicons_l10n.upgrade).attr('href', '/account/subscription-billing/')
              $('.secondary-menu__item--btn-primary > a').removeClass('d-none')
            } else {
              $('html').addClass('--pro').addClass('level-' + response.data.level)
              if (response.data.level == 'executive') {
                $('.header__pro__subscribe a').remove()
                $('.secondary-menu__item--btn-primary a').remove()
              } else {
                $('.header__pro__subscribe a').text(techicons_l10n.upgrade).attr('href', '/account/subscription-billing/')
                $('.secondary-menu__item--btn-primary a').text(techicons_l10n.upgrade).attr('href', '/account/subscription-billing/')
              }
            }
            if ('first_name' in response.data && response.data.first_name) {
              $('.--logged').html('<span>' + response.data.first_name + '<span>' + response.data.last_name + '</span>' + '</span>')
            } else if ('full_name' in response.data && response.data.full_name) {
              $('.--logged').html('<span>' + response.data.full_name + '</span>')
            }
            $('html').addClass('--logged-in')
            $('.secondary-menu__item----logged > a').removeClass('d-none')
          } else {
            $('html').addClass('--logged-out')
            $('.secondary-menu__item--js-login > a').removeClass('d-none')
            $('.secondary-menu__item--btn-primary > a').removeClass('d-none')
          }
        }
      })
    }

    $('body').click(function(event) {
      if ($(event.target).closest('.header__main-menu').length == 0 &&
      $(event.target).closest('.header__burger-wrapper').length == 0 &&
      $(event.target).closest('.chatbot-header__burger').length == 0 &&
      $(event.target).closest('.chatbot-header__menu-wrapper').length == 0) {
        if ($.mlmi.mobile) {
          if ($(event.target).closest('.search-form__container').length == 0) {
            if ($('body').hasClass('--menu-open')) {
               $('.burger').click()
            }
          }
        } else {
          if ($('body').hasClass('--menu-open')) {
             $('.burger').click()
          }
        }
      }
    })
  }
}
